import {
  Container,
  CustomRow,
  ContentWrapper,
  ContentHolder,
} from 'Layouts/Dashboard/style';
import Header from 'components/Header';
import ModalsPanel from 'pages/Modals';
// @ts-ignore
import { getAuthenticatedUser } from '@edx/frontend-platform/auth';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';
import Loader from 'elements/Loader';
import Sidebar from 'components/Sidebar';
import Footer from 'components/Footer';
import ScrollToTop from 'elements/ScrollToTop';

const Dashboard = (Content: any) => (props: any) => {
  const lmsBaseUrl = () => getConfig().LMS_BASE_URL;
  const user = getAuthenticatedUser();
  if (!user) {
    const loginUrl = new URL(`${lmsBaseUrl()}/login`);
    loginUrl.searchParams.append('next', window.location.href);
    window.location.replace(loginUrl.href);
  }

  if (!user) {
    return <Loader position='fixed' background='none' />;
  }

  return (
    <>
      <Header user={user} />
      <Container id='main' tabIndex={-1}>
        <CustomRow>
          {/* <Sidebar /> */}
          <ContentWrapper id='scrollableDiv'>
            <ContentHolder>
              <Content {...props} />
            </ContentHolder>
          </ContentWrapper>
        </CustomRow>
      </Container>
      <Footer />
      <ScrollToTop />
      <ModalsPanel />
    </>
  );
};

export default Dashboard;
